import React from "react";

export default function Workplace(props) {
  return (
    <div>
      <h1 id="workplace" className="text-3xl font-bold mb-6 text-yellow-500">
        What constitutes Workplace?
      </h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            For the purpose of this policy, SS’s workplace includes
          </span>

          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                its offices/premises at Civil Lines & Bokhara in Nagpur
                District.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                any place visited by SS’s employees and associates in connection
                with SS’s work, during the course of employment and/or arising
                out of engagement with SS.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                any mode of transport including bus station/ railway station/
                airport used for travelling to a workplace by SS’s employees and
                associates in connection with SS’s work, during the course of
                employment and/or arising out of engagement with SS.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Guest house/ hotel/hostel etc. where an employee or associate is
                staying away from their headquarter in connection with SS’s
                work, during the course of employment and/or arising out of
                engagement with SS.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
